// 专辑详情页

import request from './services/axios.js'
// 设置精度值
export default {
  bookshelfDetail: (params) => {
    return request({
      params,
      url: '/ebook/getAlbumById',
      method: 'get'
    })
  },
  bookshelfMobileDetail: (params) => {
    return request({
      params,
      url: '/ebook/mobile/getAlbumById',
      method: 'get'
    })
  }
}
